// Model.js
// -----------------------
// @module C3.PDPSerialLotFunctionality.LotItemImages
define("C3.PDPSerialLotFunctionality.LotItemImages.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    return Backbone.Model.extend({
        
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "services/LotItemImages.Service.ss"
            )
        )
    });
});
